import * as React from "react";
import {ReactNode} from "react";

export class ButtonGroupItem extends React.Component<ButtonGroupItemProps, ButtonGroupItemState> {
    static defaultProps: Partial<ButtonGroupItemProps> = {};


    constructor(props: ButtonGroupItemProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            null
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface ButtonGroupItemProps {
    Content:ReactNode;
    Value:any;
    children:any[]|any;

}

interface ButtonGroupItemState {

}

//#endregion "My Region"